import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';
/**
 * Created by max on 30/08/2017.
 */
const Flower = (props) => (
  <SvgIcon {...props}>
    <line fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="12" y1="19.7" x2="12" y2="23"/>
    <path fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
      M17.5,19.744c-0.557,0-1.093-0.015-1.599-0.037l1.599,2.559c-2.273-0.297-4.092-1.302-5.5-2.933c-1.408,1.632-3.227,2.636-5.5,2.933
      l1.599-2.559c-0.506,0.022-1.041,0.037-1.599,0.037C3.464,19.744,1,18.6,1,18.6s2.464-1.144,5.5-1.144c0.84,0,1.639,0.04,2.35,0.11
      c-0.957-0.656-2.031-1.555-3.098-2.618C3.02,12.213,2.1,8.7,2.1,8.7s3.513,0.92,6.248,3.652c0.825,0.829,1.551,1.661,2.141,2.438
      c-0.202-1.419-0.323-3.139-0.323-4.99C10.167,4.942,12,1,12,1s1.833,3.942,1.833,8.8c0,1.852-0.121,3.571-0.323,4.99
      c0.59-0.777,1.316-1.61,2.141-2.438C18.387,9.62,21.9,8.7,21.9,8.7s-0.92,3.513-3.652,6.248c-1.067,1.063-2.141,1.962-3.098,2.618
      c0.711-0.07,1.511-0.11,2.35-0.11c3.036,0,5.5,1.144,5.5,1.144S20.536,19.744,17.5,19.744z"/>
  </SvgIcon>
);

export default Flower;



// WEBPACK FOOTER //
// ./src/icons/types/Flower.jsx